export default __webpack_public_path__ + "static/media/fig-17a-inclined-io-table.be95ad83.png";